export default {

    /** 成功的消息 */
    success(vm,message) {
        vm.$message({
            message: message,
            type: 'success'
        });
    },

    /** 失败的消息 */
    error(vm,message) {
        vm.$message({
            message: message,
            type: 'error'
        });
    },

    /** 基础 */
    info(vm,message) {
        vm.$message({
            message: message,
            type: 'info'
        });
    },

    /** 警告 */
    warning(vm,message) {
        vm.$message({
            message: message,
            type: 'warning'
        });
    }
}